export enum CountriesDropdownType {
  onlyEnvironment = 'environment',
  onlySupported = 'supported',
  all = 'all'
}
